import React from 'react';
import { Modal, ModalProps } from '@vimily/bonjoro-ui-components-v2/Modal';

const videoUrl =
  'https://cdn.bonjoro.com/assets/video-assets/message-template.mp4';

export const MessageTemplateInfoModal = (props: ModalProps) => {
  return (
    <Modal
      {...props}
      className='sm:!w-[940px] !rounded-2xl !inset-px !p-0'
      overlayClassName='!z-[9999999999]'
      closeButtonClassName='!top-7.5 !right-7.5 text-[30px] !w-5'
    >
      <div className='flex flex-col gap-y-6 w-full px-8 py-10'>
        <span className='v2-text-neutral-900 text-[28px] font-bold'>
          What are message templates?
        </span>
        <span className='v2-text-neutral-900 text-base'>
          Message template consists of email template, landing page design and
          your default message. You can choose from different email layouts and
          customise message landing page with own branding and Call-To-Action.
        </span>
        <video className='w-full px-10' autoPlay loop muted playsInline>
          <source src={videoUrl} type='video/mp4' />
        </video>
      </div>
    </Modal>
  );
};
